import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { CheckBoxIconProps } from './types/CheckBoxIconProps';

export const CheckBoxIcon = ({
  flush = false,
  ...props
}: CheckBoxIconProps): ReactNode => (
  <Icon
    {...props}
    testId={locator.components.icon.checkBox}
    viewBox={flush ? '3 3 18 18' : '0 0 24 24'}
  >
    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z" />
  </Icon>
);
